import { useContext } from "react";
import { Helmet } from "react-helmet";
import { ThemeContext } from "../../context/themecontext";

import rtlLight from "../../../node_modules/@crunchyroll/cx-web-components-light/dist/styles-rtl.css";
import rtlDark from "../../../node_modules/@crunchyroll/cx-web-components/dist/styles-rtl.css";
import ltrLight from "../../../node_modules/@crunchyroll/cx-web-components-light/dist/styles-ltr.css";
import ltrDark from "../../../node_modules/@crunchyroll/cx-web-components/dist/styles-ltr.css";

const StylesLoader = () => {
  const { value } = useContext(ThemeContext);
  const isRTL = typeof window !== "undefined" && window.document.dir === "rtl";
  const isLightTheme = value === "light";

  let css;

  if (isRTL) {
    if (isLightTheme) {
      css = rtlLight;
    } else {
      css = rtlDark;
    }
  } else {
    if (isLightTheme) {
      css = ltrLight;
    } else {
      css = ltrDark;
    }
  }

  return (
    <Helmet>
      <style>{css}</style>
    </Helmet>
  );
};

export default StylesLoader;
